import React from 'react';
import { Shield, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark border-t border-gold/20 py-12 px-4 text-center" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-125">
          <Shield className="w-6 h-6 text-gold" data-id="element-126" />
          <h2 className="text-xl font-montserrat font-bold tracking-wider text-white" data-id="element-127">
            AVANZAPRO<sup className="text-xs" data-id="element-128">®</sup>
          </h2>
        </div>

        <p className="text-cream/70 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed" data-id="element-129">
          El sistema de autogestión crediticia N°1 para uruguayos con registros
          negativos que quieren salir del Clearing, frenar el acoso y recuperar
          su libertad financiera real.
          <br data-id="element-130" />
          <br data-id="element-131" />
          Porque salir del Clearing no debería costarte ni un abogado ni toda la
          angustia del mundo.
        </p>

        <div className="flex flex-col items-center gap-3 text-sm text-gold/80 mb-12" data-id="element-132">
          <a href="mailto:soporteavanzapro@gmail.com" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-133">
            <Mail className="w-4 h-4" data-id="element-134" /> soporteavanzapro@gmail.com
          </a>
          <a href="https://www.avanzapro.store" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-135">
            <Globe className="w-4 h-4" data-id="element-136" /> www.avanzapro.store
          </a>
        </div>

        <div className="text-xs text-cream/40 space-y-2" data-id="element-137">
          <p data-id="element-138">© AvanzaPro® 2026 — Todos los derechos reservados</p>
          <p data-id="element-139">Prohibida la reproducción sin autorización expresa.</p>
          <p className="mt-4 text-gold/50 font-medium" data-id="element-140">
            🇺🇾 "La próxima semana puede ser diferente."
          </p>
        </div>
      </div>
    </footer>;
}